<div sf-array="form" class="schema-form-array {{form.htmlClass}}" ng-model="$$value$$"
     ng-model-options="form.ngModelOptions"><label class="control-label" ng-show="showTitle()">{{ form.title }}</label>
  <ol class="list-group" ng-model="modelArray" ui-sortable="">
    <li class="list-group-item {{form.fieldHtmlClass}}" ng-repeat="item in modelArray track by $index">
      <button ng-hide="form.readonly || form.remove === null" ng-click="deleteFromArray($index)"
              style="position: absolute;z-index: 20;right: 10px;" type="button" class="close pull-right"><span
          aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
      <sf-decorator ng-init="arrayIndex = $index" form="copyWithIndex($index)"></sf-decorator>
    </li>
  </ol>
  <div class="clearfix" style="padding: 15px;">
    <button ng-hide="form.readonly || form.add === null" ng-click="appendToArray()" type="button"
            class="btn {{ form.style.add || 'btn-default' }} pull-right"><i class="glyphicon glyphicon-plus"></i> {{
      form.add || 'Add'}}
    </button>
  </div>
  <div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description"
       ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div>
</div>